"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var utils_1 = require("../utils");

var entities_1 = require("../entities");
/**
 * @hidden
 */


exports.createRefreshSecurityTokenResolver = function (factories, symbol) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", factories.securityTokenFactory.refresh(entities_1.SecurityToken.generateId({
                symbol: symbol
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * @hidden
 */


exports.createRefreshTokenholdersResolver = function (factories, symbol, from) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", factories.tokenholderFactory.refresh(entities_1.Tokenholder.generateId({
                securityTokenId: entities_1.SecurityToken.generateId({
                  symbol: symbol
                }),
                address: from
              })));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };
};
/**
 * Procedure that redeems (burns) Security Tokens from an account.
 * Can only be executed by the Security Token's Controller
 */


var ControllerRedeem =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(ControllerRedeem, _Procedure_1$Procedur);

  function ControllerRedeem() {
    var _this2;

    _classCallCheck(this, ControllerRedeem);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ControllerRedeem).apply(this, arguments));
    _this2.type = types_1.ProcedureType.ControllerRedeem;
    return _this2;
  }
  /**
   * Redeem tokens from a specific address, optionally providing a reason or extra data for the action
   *
   * Note this procedure will fail if:
   * - The "from" address is invalid
   * - Attempting to redeem an amount of tokens greater than the account's balance
   * - The current wallet address is not the Security Token controller address
   */


  _createClass(ControllerRedeem, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this$args, symbol, amount, from, _this$args$reason, reason, _this$args$data, data, _this$context, contractWrappers, currentWallet, factories, securityToken, _ref, _ref2, senderBalance, controller, account;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, amount = _this$args.amount, from = _this$args.from, _this$args$reason = _this$args.reason, reason = _this$args$reason === void 0 ? '' : _this$args$reason, _this$args$data = _this$args.data, data = _this$args$data === void 0 ? '' : _this$args$data;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, currentWallet = _this$context.currentWallet, factories = _this$context.factories;
                /*
                 * Validation
                 */

                if (utils_1.isValidAddress(from)) {
                  _context3.next = 4;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InvalidAddress,
                  message: "Provided \"from\" address is invalid: ".concat(from)
                });

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 7:
                securityToken = _context3.sent;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](4);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 13:
                _context3.next = 15;
                return Promise.all([securityToken.balanceOf({
                  owner: from
                }), securityToken.controller(), currentWallet.address()]);

              case 15:
                _ref = _context3.sent;
                _ref2 = _slicedToArray(_ref, 3);
                senderBalance = _ref2[0];
                controller = _ref2[1];
                account = _ref2[2];

                if (!senderBalance.lt(amount)) {
                  _context3.next = 22;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InsufficientBalance,
                  message: "Balance of ".concat(senderBalance, " is less than the requested amount of ").concat(amount, " being redeemed")
                });

              case 22:
                if (!(account !== controller)) {
                  _context3.next = 24;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "You must be the controller of this Security Token to redeem tokens. Did you remember to call \"setController\"?"
                });

              case 24:
                _context3.next = 26;
                return this.addTransaction(securityToken.controllerRedeem, {
                  tag: types_1.PolyTransactionTag.ControllerRedeem,
                  resolvers: [exports.createRefreshTokenholdersResolver(factories, symbol, from), exports.createRefreshSecurityTokenResolver(factories, symbol)]
                })({
                  from: from,
                  value: amount,
                  data: data,
                  operatorData: reason
                });

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 10]]);
      }));
    }
  }]);

  return ControllerRedeem;
}(Procedure_1.Procedure);

exports.ControllerRedeem = ControllerRedeem;